import { Types as AblyTypes } from "ably";
import { ApiResponse } from "admin/src/ui/types/common/api-response";
import { ApiQueryConfig } from "api/types";

const GetAblyTokenCreation: ApiQueryConfig<
  ApiResponse<AblyTypes.TokenDetails>,
  { societyId: string },
  Record<string, never>
> = {
  apiPath: "/api/v1/society/{societyId}/ably-create-token-request",
  queryKey: {
    baseQueryKey: ["GetAblyTokenCreation"],
    dynamicQueryKey: ["societyId"],
  },
};

export { GetAblyTokenCreation };
